import React from 'react';
export function Reviews() {
  const reviews = [{
    text: 'En dos semanas ya tenía mi primer proveedor del Once y mis primeras 5 ventas. El guión de WhatsApp que viene en el Tomo 5 es oro puro. Literalmente.',
    author: 'Marcela D.',
    location: 'Rosario — Vendedora de joyas desde casa'
  }, {
    text: 'Llevaba meses buscando en YouTube sin resultados. Con el sistema entendí cómo calcular mi margen, cómo hablar con un proveedor y cómo no caer en una estafa. Todo junto, todo en argentino.',
    author: 'Hernán T.',
    location: 'CABA — Emprendedor de joyería'
  }, {
    text: 'Lo del directorio de ferias cambió todo. Fui a la primera feria del listado, volví con $47.000 de ganancia neta. Difícil de creer hasta que me pasó a mí.',
    author: 'Soledad P.',
    location: 'Córdoba — Feriante de joyas y accesorios'
  }];
  return <section className="bg-[linear-gradient(180deg,rgba(201,168,76,0.03)_0%,transparent_100%)] py-10 sm:py-14" data-id="element-264">
      <div className="mx-auto max-w-[1040px] px-6" data-id="element-265">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-266">
          {reviews.map((review, i) => <div key={i} className="rounded-xl border border-border bg-card p-6" data-id="element-267">
              <div className="mb-3 text-[13px] text-gold" data-id="element-268">★★★★★</div>
              <p className="mb-4 text-[13px] italic leading-[1.65] text-text" data-id="element-269">
                <span className="mr-0.5 align-[-4px] font-serif text-[20px] leading-none text-gold" data-id="element-270">
                  "
                </span>
                {review.text}
              </p>
              <div className="text-[12px] text-muted" data-id="element-271">
                <strong className="block font-bold text-text" data-id="element-272">
                  {review.author}
                </strong>
                {review.location}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}